<template>
  <v-container fluid grid-list-lg>
    <v-layout>
      <v-flex>
        <v-card>
          <v-toolbar dark>
            <v-toolbar-title class="white--text">{{ location.name}} - {{ location.address }}</v-toolbar-title>
          </v-toolbar>
          <v-tabs dark slider-color="yellow" >
            <v-tab ripple v-for="(tab, index) in tabs" :key="index">{{ tab.name }}</v-tab>
            <v-tabs-items>
              <v-tab-item lazy v-for="(tab, index) in tabs" :key="index">
                <component :is="tab.component" :location-id="locationId"></component>
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import LocationSales from '@/components/Location/Sales'
import LocationTransactions from '@/components/Location/Transactions'

import locationService from '@/services/location'

export default {
  components: {
    LocationSales,
    LocationTransactions
  },

  props: {
    id: [String, null]
  },

  data () {
    return {
      loading: false,
      location: {},
      tabs: [
        {
          name: 'Monthly Sales',
          component: 'LocationSales'
        },
        {
          name: 'Transactions',
          component: 'LocationTransactions'
        }
      ]
    }
  },

  computed: {
    locationId () {
      return this.id || this.$route.params.id
    }
  },

  methods: {
    async getLocation () {
      this.loading = true

      const { data } = await locationService.get(this.locationId)
      this.location = data.data

      this.loading = false
    }
  },

  created () {
    this.getLocation()
  }
}
</script>

<style>

</style>
